import React from 'react';
import { Icon, Text } from '@oneaudi/unified-web-components';
import type { IconNamesType } from '@oneaudi/unified-web-components/dist/cjs/components/icon/icon-names.generated';
import { DealerDetailStyled, DealerTelStyled, StyledLayout } from './DealerDetailStyles';
import type { Dealer } from '../../interfaces/header-components.interfaces';
import { PoiIcon } from '../Icons/PoiIcon';
import { NAVIGATION_CLASSNAME } from '../../utils/globals';
import { keyTypes } from '../../utils/a11y';

export interface DealerDetailProps {
  icon?: IconNamesType | 'poi-icon';
  detail?: Dealer['address'] | string;
}

export const DealerDetail: React.FC<DealerDetailProps> = ({ icon, detail }) => {
  const detailsArray = typeof detail === 'string' ? [detail] : detail;

  const onClickCall = (telNumber: string, e?: React.KeyboardEvent) => {
    if (
      typeof window === 'undefined' ||
      e?.key === keyTypes.Tab ||
      e?.key === keyTypes.ArrowDown ||
      e?.key === keyTypes.ArrowUp
    )
      return;
    window.location.href = `tel: ${telNumber}`;
  };

  return (
    <DealerDetailStyled>
      {icon && (
        <StyledLayout align="center" className="icon">
          {icon === 'poi-icon' ? <PoiIcon /> : <Icon name={icon} size="s" />}
        </StyledLayout>
      )}
      <StyledLayout>
        {detailsArray &&
          detailsArray.map((detailText: string, index: number) => {
            return icon === 'voice-call-1' ? (
              <DealerTelStyled
                role="button"
                key={detailText}
                tabIndex={index}
                onKeyDown={(e) => {
                  onClickCall(detailText, e);
                }}
                onClick={() => {
                  onClickCall(detailText);
                }}
                className={NAVIGATION_CLASSNAME}
              >
                <Text aria-label={detailText}>{detailText}</Text>
              </DealerTelStyled>
            ) : (
              <Text aria-label={detailText} key={detailText}>
                {detailText}
              </Text>
            );
          })}
      </StyledLayout>
    </DealerDetailStyled>
  );
};
